export const getUpcomingEventsListApi = (query,leaseSlug,assetType,assetId) => {
        const queryString = new URLSearchParams(query).toString();
    return `lease/${leaseSlug}/upcoming_events/${assetType}/${assetId}/${queryString ? `?${queryString}` : ''}`
};